import { PageHead } from "@/components/utils";
import { FadeUp } from "@/components/Reveal";
import { REVIEW_PROMPTS, BUSINESS } from "@/lib/data";
import { Star, ArrowUpRight } from "lucide-react";

export default function Reviews() {
  return (
    <>
      <PageHead
        title="Reviews — Good Looks Unisex Salon"
        description="Read and share honest reviews of Good Looks Unisex Salon, Mansa."
      />
      <section className="bg-[#F3EAD9] pt-40 pb-24">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10">
          <FadeUp>
            <p className="eyebrow text-[#C89B3C] mb-6">— Reviews</p>
            <h1 className="font-display text-5xl md:text-8xl leading-[0.95] max-w-5xl">
              Real words from<br /><span className="italic">real regulars.</span>
            </h1>
          </FadeUp>

          <FadeUp delay={0.1}>
            <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {REVIEW_PROMPTS.map((p, i) => (
                <div key={i} className="border border-black/10 p-8 md:p-10 bg-white">
                  <div className="flex gap-1 text-[#C89B3C] mb-6">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <Star key={s} size={16} fill="#C89B3C" strokeWidth={0} />
                    ))}
                  </div>
                  <p className="font-display text-2xl leading-tight text-black/80 italic">
                    &ldquo;{p}&rdquo;
                  </p>
                  <p className="eyebrow text-black/40 mt-8">Prompt · placeholder</p>
                </div>
              ))}
            </div>
          </FadeUp>

          <div className="mt-16 border border-black/10 bg-[#1B1B1B] text-[#F3EAD9] p-8 md:p-14 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="max-w-xl">
              <p className="eyebrow text-[#C89B3C] mb-3">— Leave a review</p>
              <h3 className="font-display text-3xl md:text-4xl leading-tight">
                Loved your visit? Tell others.
              </h3>
              <p className="text-white/60 mt-3 text-sm">
                We're building our reviews the honest way — one guest at a time.
                Share your experience on Google or Instagram.
              </p>
            </div>
            <a
              href={BUSINESS.social.instagram}
              className="btn-gold"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Tag us on Instagram</span>
              <ArrowUpRight size={16} />
            </a>
          </div>
          <p className="mt-6 text-xs text-black/50 italic">
            No reviews are invented or displayed here without explicit permission.
          </p>
        </div>
      </section>
    </>
  );
}
